/**
 * Order sheet (用紙発注) constants.
 */

export const QUANTITY_OPTIONS = [
  { value: undefined, label: '' },
  ...Array.from({ length: 9 }, (_, i) => ({ value: i + 1, label: String(i + 1) })),
  ...Array.from({ length: 10 }, (_, i) => ({ value: (i + 1) * 10, label: String((i + 1) * 10) })),
];
